<style></style>
<template>
    <div class="container invites">
        <div class="form-group">
            <label>New Registration Code:</label>
            <BFormInput v-model="new_code.reg_code" type="text"></BFormInput>
        </div>
      
       
        <BFormGroup label="Status:">
            <BFormRadioGroup v-model="new_code.enabled" :options="status_options">
            </BFormRadioGroup>
        </BFormGroup>
        <button class="btn btn-orange-blue" @click="createCode">Submit</button>
    </div>
</template>
<script>
    export default {
        props: {
            partners: {
                type: Array,
                required: true
            },
            consultants: {
                type: Array,
                required: true
            },
        },
        data() {
            return {
                new_code: {},
                status_options: [
                    { text: 'Enabled', value: 1 },
                    { text: 'Disabled', value: 0 }
                ]
            }
        },
        computed: {
            partner_options: function () {
                let options = [];
                for (var i = 0; i < this.partners.length; i++) {
                    options.push({'value':this.partners[i].id, 'text': this.partners[i].name})
                }
                return options
            },
            consultant_options: function () {
                let options = [];
                for (var i = 0; i < this.consultants.length; i++) {
                    options.push({'value':this.consultants[i].id, 'text': this.consultants[i].name})
                }
                return options
            },
            
            codeErrorText: function() {
                return "This partner is inactive and cannot been assigned a registration code.";
            }
        },
        methods: {
            initCodeObject () {
                this.new_code = {}
                this.new_code.reg_code = this.generateRUCString()
            },
            generateRUCString () { // 8 character random upper case string
                let chars = "ABCDEFGHIJKLMNOPQRSTUVWXTZ"
                let string = ''
                for (let i = 0; i < 8; i++) {
                    let rnum = Math.floor(Math.random() * chars.length)
                    string += chars.substring(rnum, rnum + 1)
                }
                return string
            },
            createCode() {
                axios.post('/api/registration-codes', {
                    code: this.new_code.reg_code,
                   
                    enabled: this.new_code.enabled
                })
                .then(function (response) {
                    this.$emit('codeCreated')
                    this.initCodeObject()
                }.bind(this))
                    .catch(function (error) {
                        console.error(error)
                    })
            },
            // getPartners() {
            //     axios.get('/api/partners')
            //     .then(function (response) {
            //         this.partners = response.data.data
            //     }.bind(this))
            //     .catch(function (error) {
            //         console.error(error)
            //     })
            // },
            // getConsultants() {
            //     axios.get('/api/consultants')
            //     .then(function (response) {
            //         this.consultants = response.data.data
            //     }.bind(this))
            //     .catch(function (error) {
            //         console.error(error)
            //     })
            // },
        },
        mounted() {
            this.initCodeObject();
        }
    }
</script>